// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"14158241","234":"67f41d8f","329":"3e03ffa8","407":"31144de4","453":"5e560239","714":"6d54c2e3","885":"a0d67c88"}[chunkId] + ".chunk.js";
};